<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path d="M15 35L27.7626 22.2374C28.446 21.554 28.446 20.446 27.7626 19.7626L15 7" stroke="white" stroke-width="3.5" stroke-linecap="round"/>
    </svg>
</template>